import React from 'react';

import { scrollToWithNav } from './scrollToWithNav';

export const ScrollHere: React.FC = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  React.useEffect(() => {
    if (scrollRef?.current) {
      scrollToWithNav(scrollRef.current.getBoundingClientRect().top + window.pageYOffset - 50);
    }
  }, [scrollRef]);

  return <div ref={scrollRef} />;
};
